import { Identifiable, Resource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleUpdateOrganizationalUnitSuccess(
  resource: Identifiable<Resource>,
  {
    organizationalUnit,
    assignedResources,
    unassignedResources,
  }: Boundaries["updateOrganizationalUnit"]["success"],
): Identifiable<Resource> {
  const updatedResource = [...assignedResources, ...unassignedResources].find(
    ({ uuid }) => uuid === resource.uuid,
  );

  if (updatedResource) {
    return {
      ...resource,
      organizationalUnit: updatedResource.organizationalUnit,
    };
  }

  // A renamed unit is renamed on the resources it already holds.
  return resource.organizationalUnit?.uuid === organizationalUnit.uuid &&
    resource.organizationalUnit.name !== organizationalUnit.name
    ? {
        ...resource,
        organizationalUnit: {
          ...resource.organizationalUnit,
          name: organizationalUnit.name,
        },
      }
    : resource;
}

export { handleUpdateOrganizationalUnitSuccess };
